import React, { useState } from 'react';
import './App.css';
import LoginPage, { FleetUser } from './pages/LoginPage';
import TopStrip, { FleetView } from './components/TopStrip';
import InstanzenPage from './pages/InstanzenPage';
import InstanzDetailPage from './pages/InstanzDetailPage';
import OperatorenPage from './pages/OperatorenPage';
import RolloutPage from './pages/RolloutPage';
import FreigabePage from './pages/FreigabePage';
import SystemPage from './pages/SystemPage';
import EinstellungenPage from './pages/EinstellungenPage';
import ProvisionierenPage from './pages/ProvisionierenPage';

function restoreUser(): FleetUser | null {
  const raw = localStorage.getItem('fleet_user');
  if (!raw) return null;
  try {
    return JSON.parse(raw) as FleetUser;
  } catch {
    return null;
  }
}

const App: React.FC = () => {
  const [token, setToken] = useState<string | null>(localStorage.getItem('fleet_token'));
  const [user, setUser] = useState<FleetUser | null>(restoreUser());
  // Bewusst State statt react-router: ein internes Werkzeug mit vier Ansichten
  // braucht keine Routing-Abhaengigkeit. Preis: kein Deep-Link.
  const [view, setView] = useState<FleetView>('instanzen');
  const [aktiverSlug, setAktiverSlug] = useState<string | null>(null);

  // Öffentliche Freigabe-Seite: /freigabe?token=… wird unabhängig vom Login gerendert.
  const _params = new URLSearchParams(window.location.search);
  const freigabeToken =
    window.location.pathname === '/freigabe' ? _params.get('token') : null;
  if (freigabeToken) {
    return <FreigabePage token={freigabeToken} />;
  }

  const handleLogin = (newToken: string, newUser: FleetUser) => {
    setToken(newToken);
    setUser(newUser);
    setView('instanzen');
  };

  const handleLogout = () => {
    localStorage.removeItem('fleet_token');
    localStorage.removeItem('fleet_user');
    setToken(null);
    setUser(null);
  };

  const oeffneInstanz = (slug: string) => {
    setAktiverSlug(slug);
    setView('detail');
  };

  if (!token || !user) {
    return <LoginPage onLogin={handleLogin} />;
  }

  return (
    <div className="k-app">
      <TopStrip
        currentView={view}
        user={user}
        onNavigate={setView}
        onLogout={handleLogout}
      />
      <main className="k-main">
        {view === 'instanzen' && <InstanzenPage onOeffnen={oeffneInstanz} />}
        {view === 'detail' && aktiverSlug && (
          <InstanzDetailPage slug={aktiverSlug} onZurueck={() => setView('instanzen')} />
        )}
        {view === 'operatoren' && <OperatorenPage aktuellerBenutzer={user} />}
        {view === 'rollout' && <RolloutPage />}
        {view === 'system' && <SystemPage />}
        {view === 'einstellungen' && <EinstellungenPage />}
        {view === 'provisionieren' && <ProvisionierenPage />}
      </main>
    </div>
  );
};

export default App;
